import React from "react";
import ChangeColor from "@Features/viewer-toolbar/components/ToolbarViewer/ChangeColor";

function Measurement({
  onClick,
  color,
  size,
}: {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  color?: string;
  size?: string | number;
}) {
  const dimensions = size || 24;
  return (
    <svg
      onClick={onClick}
      width={dimensions}
      height={dimensions}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <linearGradient id="measurement" gradientTransform="rotate(45)">
        <stop offset="38%" stopColor={color} />
        <stop offset="92%" stopColor={ChangeColor(color)} />
      </linearGradient>
      <path d="M5.294 9.883v5.17h5.36l-1.117-1.078H6.412v-3.014L5.294 9.883z" fill="#192048" />
      <path
        d="m19.755 17.912-1.604-1.569v1.413H2.5v-2.238h1.118v-.862H2.5V11.07h1.118v-.862H2.5v-3.45h1.118v-.863H2.5V2.88l8.91 8.545v-1.52L2.338 1.199a.578.578 0 0 0-.611-.118.555.555 0 0 0-.252.2.525.525 0 0 0-.093.3v16.714c0 .143.059.28.164.381a.57.57 0 0 0 .395.158h17.417c.111.001.22-.03.313-.09a.544.544 0 0 0 .207-.242.52.52 0 0 0-.123-.59z"
        fill="#192048"
      />
      <path
        d="M13.678 16.671h2.236c.297 0 .581-.113.79-.316a1.06 1.06 0 0 0 .328-.762V5.187l-1.285-2.28a1.1 1.1 0 0 0-.416-.399 1.15 1.15 0 0 0-.568-.14 1.148 1.148 0 0 0-.576.159 1.094 1.094 0 0 0-.408.423L12.56 5.198v10.395c0 .286.118.56.328.762.21.203.494.316.79.316zm0-11.214 1.085-2.033 1.151 2.038v7.974h-2.236v-7.98zm0 8.858h2.236v1.316h-2.236v-1.316z"
        fill="#192048"
      />
    </svg>
  );
}

export default Measurement;
